import React, { PureComponent } from 'react';
import t from 'prop-types';

import PortalContext from './private/PortalContext';
import PortalCreator from './private/PortalCreator';
import PortalProvider from './private/PortalProvider';

/**
 * @class
 */
class Portal extends PureComponent {
  componentDidMount() {}

  /**
   * @returns {React.Element}
   */
  render() {
    const { children, refProp } = this.props;
    return (
      <PortalContext.Consumer>
        {portalProps => (
          <PortalCreator ref={refProp} {...portalProps}>
            {children}
          </PortalCreator>
        )}
      </PortalContext.Consumer>
    );
  }
}

if (process.env.NODE_ENV !== 'production') {
  Portal.propTypes = {
    children: t.node,
    /**
     * ref для доступа к элементу портала
     */
    refProp: t.any, // eslint-disable-line react/forbid-prop-types
  };
}

Portal.defaultProps = {
  children: [],
  refProp: undefined,
};

Portal.Provider = PortalProvider;

export { PortalProvider, Portal as default };
